import Vue from 'vue'
import App from './App.vue'

import { store, mutations, actions } from './store'
import { EventBus } from './event-bus'
import { util } from './util'
import { icons } from './icons'
import VueGlobalVar from 'vue-global-var'
Vue.use(VueGlobalVar, {
  globals: {
    $icons: icons,
    $util: util,
    $event: EventBus,
    $store: store,
    $commit: mutations,
    $dispatch: actions
  }
})

Vue.config.productionTip = false
Vue.config.devtools = true

window.addEventListener('load', function() {

  const elems = Array.from(document.querySelectorAll('.vue-form'))
  const form_instances = []
    
  if (elems.length) {
    for (const elem of elems) {

      try {
        const config = JSON.parse(
          document.getElementById('vue-form-config-' + elem.dataset.id).innerHTML
        )

        this.$dispatch.setup({
          config: config,
          token: elem.dataset.t
        })

        const vueData = Object.assign({
          appid: elem.dataset.id,
          el: elem
        }, App)
        form_instances.push(new Vue(vueData))
      } catch (e) {
        console.log(e)
      }
    }
  }
})